<template>
    <div class="h-100 ecomm-font-family">
        
        <div class="position-sticky sticky-top " v-if="headerStatus">
            <b-navbar class="pb-0 pt-2 navbar-light bg-white">
                <div class="pr-3 pl-3 container-first-nav" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid': storeDetails.ui_layout==2 ? true : false}" >
                    <ul class="navbar-nav first-navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto ml-auto">
                        <li class="nav-item  search-nav" v-if="showSearchInputStatus">
                            <a class="nav-link nav-link-icon first-nav-link " @click.prevent="showSearch" @mouseleave="mouseLeave()">
                                <span :hidden="!showSearchInputOnClick">
                                    <a-input-search placeholder="input search text" v-model="search" style="width: 200px" @search="onSearch" />
                                </span>
                                <i class="fa fa-search" aria-hidden="true" :hidden="showSearchInputOnClick"></i>
                            </a>
                        </li>
                        <li class="nav-item" v-if="loginStatus!=true">
                            <router-link :to="{ name: 'customer_login', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}"
                                class="nav-link first-nav-link ">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </router-link>
                        </li>
                        <base-dropdown v-else-if="loginStatus==true" tag="li" class="nav-item">
                            <a slot="title" class="nav-link first-nav-link " data-toggle="dropdown" role="button">
                                <i class="fa fa-user" aria-hidden="true"></i>
                            </a>
                            <router-link :to="{ name: 'account', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}" class="dropdown-item" type="button">Account</router-link>
                            <a class="dropdown-item" v-if="gmailLoginStatus!=true && fbLoginStatus!=true" type="button" @click.prevent="logout">Logout</a>
                            <a class="dropdown-item" v-if="fbLoginStatus==true" type="button" @click.prevent="fbLogout">Logout</a>
                            <GoogleLogin class="dropdown-item"  v-if="gmailLoginStatus==true" :params="params" :logoutButton=true :onSuccess="onSuccess">Logout</GoogleLogin>
                        </base-dropdown>
                        <li class="nav-item">
                            <router-link :to="{ name: 'cart', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}"
                                class="nav-link first-nav-link" v-bind:class="{'pr-0': storeDetails.ui_layout==1 ? true : false, 'pr-2': storeDetails.ui_layout==2 ? true : false}">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                                <sup v-if="orderCount>0"><badge class="badge-pill font-weight-bold" tag="a" type="primary">{{orderCount}}</badge></sup>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </b-navbar>
        <!-- <div class="position-sticky sticky-top bg-custom-navbar" v-if="headerStatus"> -->
            <base-nav class="navbar navbar-light bg-white pt-2 pb-2" v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}" type="" expand>
                <router-link slot="brand" class="navbar-brand mr-lg-5" :to="{ name: 'store', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}">
                    <img v-if="storeDetails.icon_name!=null" :src="logoUrl" @error="$event.target.src='/img/barter-full.2bb364be.png'" alt="logo">
                    <img v-else src='@/assets/barter-full.png' alt="logo">
                </router-link>
                <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto mw-500px custom-scrollbar-css-x " v-bind:class="{'overflow-auto' : navbarWidth!=null && navbarWidth < 500 ? true : false, 'custom-scrollbar-css-x111' : navbarWidth!=null && navbarWidth <= 500 ? true : false}" ref="navbar" style="white-space: nowrap;">
                    <li class="nav-item">
                        <router-link :to="{ name: 'store', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}"
                            class="nav-link ">
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">Home</span>
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{ name: 'catalog', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}"
                            class="nav-link ">
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">Catalog</span>
                        </router-link>
                    </li>
                    <li class="nav-item" v-for="(collection,index) in collections" v-bind:key="collection.key">
                        <span v-if="index == collections.length-1">
                            {{getNavbarWidth()}}
                        </span>
                        <a class="nav-link " @click.prevent="goToCollection(collection.id)">
                            <i class="ni ni-ui-04 d-lg-none"></i>
                            <span class="nav-link-inner--text">{{collection.collection_name}}</span>
                        </a>
                    </li>
                </ul> 
            </base-nav>
        </div>
        <fade-transition :duration="200" origin="center top">
            <router-view @getOrderCount="getOrderCount" @hideFooterAndHeader="hideFooterAndHeader" @showFooterAndHeader="showFooterAndHeader" @checkLoginStatus="checkLoginStatus" @storeDetails="storeDetails" @showSearchInput="showSearchInput" @hideSearchInput="hideSearchInput"/>
        </fade-transition>
        <cookie-consent :cookieName="cookieName">
            <template
              slot="message"
            >
              This website uses cookies
              <a class="btn btn-link" href="#">Read more</a>
            </template>

            <template
              slot="button"
            >
              <button class="btn btn-info" v-on:click="SetDateTime">Accept</button>
            </template>
        </cookie-consent>
        <footer class="has-cards pb-3 pt-lg-4" v-if="footerStatus" style="background:#F9F9FB">
        <!-- <footer class="footer has-cards pb-3" v-if="footerStatus"> -->
            <div v-bind:class="{'container': storeDetails.ui_layout==1 ? true : false , 'container-fluid pr-5 pl-5': storeDetails.ui_layout==2 ? true : false}">
                <div class="row row-grid align-items-center my-md">
                    <div class="col-lg-6 ">
                        <a href="https://www.iripple.com" class="mr-0">
                            <img v-if="storeDetails.icon_name!=null" :src="logoUrl" @error="$event.target.src='/img/barter-full.2bb364be.png'" alt="logo" height="20px">
                            <img v-else src='@/assets/barter-full.png' alt="logo" height="20px">
                        </a>
                        <br>
                        <p class="mb-1 p-1" v-if="storeDetails.instagram_url!=null && storeDetails.instagram_url!='' || storeDetails.facebook_url!=null && storeDetails.facebook_url!=''"><strong>Contact Details</strong></p>
                        <div class="p-1">
                            <a v-if="storeDetails.instagram_url!=null && storeDetails.instagram_url!='' && storeDetails.instagram_url!=undefined" class="btn btn-neutral btn-icon-only btn-round btn-lg" @click="redirectLink(storeDetails.instagram_url)">
                                <i class="fab fa-instagram"></i>
                            </a>
                            <a v-if="storeDetails.facebook_url!=null && storeDetails.facebook_url!='' && storeDetails.facebook_url!=undefined" class="btn btn-neutral btn-icon-only btn-round btn-lg" @click="redirectLink(storeDetails.facebook_url)">
                                <i class="fab fa-facebook-f"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-lg-6 btn-wrapper">
                        <h3 class="text-primary font-weight-light mb-2">Thank you for supporting us!</h3>
                        <h4 class="mb-0 font-weight-light">Let's get in touch on any of these platforms.</h4>
                    </div>
                </div>
                <hr class="mb-3">
                <div class="row align-items-center justify-content-md-between">
                    <div class="col-md-12">
                        <div class="copyright">
                                &copy; Copyright, {{year}}
                            <a href="https://www.iripple.com" class="float-right mr-0">
                                Powered by
                                <img src='@/assets/barter-full.png' alt="logo" height="20px">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
import secureStorage from '../controllers/secureStorage.js';
import BaseNav from "@/components/BaseNavOnlineStore";
import { FadeTransition } from 'vue2-transitions';
import HTTPRequest from '../controllers/httpRequest.js'
import CookieConsent from 'vue-cookieconsent-component'
import GoogleLogin from 'vue-google-login'
import { mapState} from 'vuex'

export default {
    components: {
        BaseNav,
        FadeTransition,
        HTTPRequest,
        CookieConsent,
        GoogleLogin
    },
    computed: {
        ...mapState(['endPoint', 'parameters','publicUrl'])
    },
    data(){
        return {
            year: new Date().getFullYear(),
            orderCount:0,
            headerStatus:true,
            footerStatus:true,
            storeDetails:{},
            collections:[],
            cookieName: this.$route.params.storeName +'_'+this.$route.params.accountName+'_cookieconsent_status',
            loginStatus:null,
            gmailLoginStatus:null,
            fbLoginStatus:null,
            params: {
                client_id: "157339439449-sfmoirvcm6uvluhu9d5421jtjm2vlrsr.apps.googleusercontent.com"
            },
            scope: {},
            showSearchInputOnClick:false,
            showSearchInputStatus:false,
            search:null,
            logoUrl:null,
            navbarWidth:null,
        }
    }, 
    mounted: async function(){
        secureStorage.setItem("storeName",secureStorage.getItem("SalesChannelDetails").name)
        this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
        this.storeDetails = secureStorage.getItem("SalesChannelDetails")
        this.collections = secureStorage.getItem("collections")
        this.loginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
        this.getOrderCount()
        this.getNavbarWidth()
        this.logoUrl = this.publicUrl+'online_store_images/'+this.storeDetails.icon_name
        console.log(this.storeDetails)
    },
    methods:{
        getOrderCount: async function(data){
            var gData = undefined
            if (data!=undefined){
                gData = data
            }else {
                if(this.loginStatus){
                    var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_cart_items?account_id='+this.storeDetails.account_id+'&sales_channel_id='+this.storeDetails.id+'&customer_id='+secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id, null)
                    gData = response;
                }else{
                    gData = secureStorage.getItem("OrderListData"+this.storeDetails.name);
                }
            }
            this.orderCount = 0
            if (gData !='' && gData !=null){
                for(let i = 0; i < gData.length; i++){
                    this.orderCount += gData[i].quantity;
                }
            }
        },
        hideFooterAndHeader: function(){
            this.headerStatus = false;
            this.footerStatus = false;
        },
        showFooterAndHeader:function(){
            this.getOrderCount()
            this.headerStatus = true;
            this.footerStatus = true;
        },
        goToCollection (collection_id){
            this.$router.replace({ name: 'collection', params: { collectionId: collection_id }})
        },
        SetDateTime(){
            CookieConsent.methods.setCookie(this.storeDetails.account_id+'-'+this.storeDetails.name+"-cookieconsent-datetime",new Date())
        },
        logout(){
            secureStorage.removeItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin")
            secureStorage.removeItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.checkLoginStatus()
            this.$notification['success']({
                message: 'Successfully logout',
            });
        },
        checkLoginStatus(){
            this.loginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.gmailLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-gmailStatus")
            this.fbLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-fbStatus")
            this.scope = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-FB")
            var gData = secureStorage.getItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name);
            this.createCartItems(secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin"),gData)
            secureStorage.setItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name,[])
            if (this.$router.currentRoute.name == "account" || this.$router.currentRoute.name == "orders" || this.$router.currentRoute.name == "address"){
                this.$router.push({ name: "store"})
            }else if(this.$router.currentRoute.name == "cart"){
                this.$router.go({ name: this.$router.currentRoute.name})
            }else {
                this.$router.push({ name: this.$router.currentRoute.name})
            }
        },
        onSuccess(){
            this.logout()
        },
        fbLogout(){
            this.logout()
            this.scope.logout(function(res){
            })
        },
        mouseLeave(){
            this.showSearchInputOnClick = false 
        },
        onSearch(value){
            this.$router.push({ name: this.$router.currentRoute.name, params: this.$router.currentRoute.params, query: { search: value }})
            console.log(this.$route)
            this.search = null
        },
        showSearch(){
            this.showSearchInputOnClick = true
        },
        showSearchInput: function(){
            this.showSearchInputStatus = true
        },
        hideSearchInput: function(){
            this.showSearchInputStatus = false
        },
        redirectLink(url){
            if(url!=null && url!='' && url!=undefined){
                var search = url.search('https://')
                if(search>=0){
                    window.location.href = url
                }else{
                    window.location.href = 'https://'+url
                }
            }
        },
        getNavbarWidth(){
            if (this.$refs["navbar"]!=undefined){
                this.navbarWidth = this.$refs["navbar"].clientWidth
            }
        },
        createCartItems: async function(customer_account,items){
            if(this.loginStatus==true && items.length>0){
                var response = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_cart_items/mass_create', null, {data:items,customer_id:customer_account.id,sales_channel_id:secureStorage.getItem("SalesChannelDetails").id})
                console.log(response)
                if(response["error"]==undefined){
                    
                }else{
                    this.errorMessage = response["error"].split(",")
                }
            }
        }
    }
};
</script>
<style>
.position-relative {
    position: relative!important;
}
.section-lg {
    padding-top: 6rem;
    padding-bottom: 6rem;
}
.section {
    position: relative;
    padding-top: 4rem;
    padding-bottom: 4rem;
}
.section-shaped {
    margin: 180px 0;
}
.mb-0, .my-0 {
    margin-bottom: 0!important;
}
/* .section-shaped .shape-style-1.shape-default {
    background: linear-gradient(150deg,#7795f8 15%,#6772e5 70%,#555abf 94%);
}
.section-shaped .shape-default {
    background: linear-gradient(150deg,#7795f8 15%,#6772e5 70%,#555abf 94%);
} */
.section-shaped .shape-skew {
    -webkit-transform: skewY(-8deg);
    transform: skewY(-8deg);
    -webkit-transform-origin: 0;
    transform-origin: 0;
}
.section-shaped .shape {
    position: absolute;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 90%;
}
.section-shaped .shape+.container {
    position: relative;
    padding-top: 6rem;
    padding-bottom: 0;
    height: 100%;
}
.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
sup {
    top: -1em;
    position: relative;
    font-size: 75%;
    line-height: 0;
    vertical-align: baseline;
}
.cookie-consent {
    left: 0;
    right: 0;
    bottom: 0;
}
/* .bg-custom-navbar {
    background:linear-gradient(150deg,#7795f8 15%,#6c7deb 70%,#656fe1 100%);
} */
.navbar-brand img {
    height: 30px;
}
body {
    background-color:#ffff;
}
@media (max-width: 767.98px){
    .first-navbar-nav .first-nav-link {
        padding: .625rem 0;
        color: rgba(0, 0, 0, 0.95)!important;
    }
    .container-first-nav{
        padding-right: 0px!important;
    }
}
.ecomm-font-family {
    font-family: "Inter"!important;
}
.sticky-top{
    z-index: 10!important;
}
.mw-500px {
    max-width:500px;
    min-width:100px;
    overflow:hidden;
}
.ant-list-header, .ant-list-footer {
    padding-top: 6px;
    padding-bottom: 6px;
}
.custom-scrollbar-css-x::-webkit-scrollbar {
    width: 5px!important;
    height: 3px!important;
}
.custom-scrollbar-css-x::-webkit-scrollbar-track {
    background: #8080801f!important;
}
.custom-scrollbar-css-x::-webkit-scrollbar-thumb {
    border-radius: 1rem!important;
    background-color: #54595973!important;
}
.custom-scrollbar-css-x111:hover {
    overflow-x: scroll;
}
.navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, 0.70);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
    color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link.active {
    color: rgba(0, 0, 0, 1);
}
</style>
<style lang="scss">
    @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
</style>